export const addAgentFields = [
  {
    name: "name",
    label: "Имя",
    placeholder: "Введите имя",
    validation: { required: "Заполните поле" },
  },
  {
    name: "surname",
    label: "Фамилия",
    placeholder: "Введите фамилию",
    validation: { required: "Заполните поле" },
  },
  {
    name: "phone_number",
    label: "Номер телефона",
    placeholder: "Введите номер телефона",
    validation: { required: "Заполните поле" },
  },
  {
    name: "whats_app",
    label: "Номер Whats App",
    placeholder: "Введите номер Whats App",
    validation: { required: "Заполните поле" },
  },
  {
    name: "group",
    label: "Группа",
    placeholder: "Введите группу",
    validation: { required: "Заполните поле" },
  },
  {
    name: "email",
    label: "Эл.почта",
    placeholder: "Введите почту",
    validation: { required: "Заполните поле" },
  },
  {
    name: "password",
    label: "Пароль",
    placeholder: "Введите пароль",
    validation: { required: "Заполните поле" },
  },
];
export const inputFields = [
  {
    name: "owner_name",
    label: "Контактное лицо",
    placeholder: "John Doe",
    type: "text",
    validation: { required: "Заполните поле" },
  },
  {
    name: "on_hand",
    label: "Цена на руки",
    placeholder: "Введите цену на руки",
    type: "text",
    validation: { required: "Заполните поле" },
  },
  {
    name: "price",
    label: "Цена",
    placeholder: "Введите цену",
    type: "text",
    validation: { required: "Заполните поле" },
  },
  {
    name: "phone_name",
    label: "Телефон",
    placeholder: "123-456-7890",
    type: "text",
    validation: { required: "Заполните поле" },
  },
  {
    name: "additional_phone_num",
    label: "Доп. телефон",
    placeholder: "098-765-4321",
    type: "text",
  },
  {
    name: "area",
    label: "Общая площадь (м²)",
    placeholder: "Введите общую площадь",
    type: "number",
    validation: { required: "Заполните поле" },
  },
  {
    name: "street_crossing",
    label: "Пересечение улиц",
    placeholder: "Main St and 2nd Ave",
    type: "text",
  },
  {
    name: "description",
    label: "Описание",
    placeholder: "Введите описание",
    type: "textarea",
    validation: { required: "Заполните поле" },
  },

  // {
  //   name: "latitude",
  //   label: "Широта",
  //   placeholder: "41.40338",
  //   type: "number",
  //   validation: { required: "Заполните поле" },
  // },
  //
  // {
  //   name: "longitude",
  //   label: "Долгота",
  //   placeholder: "2.17403",
  //   type: "number",
  //   validation: { required: "Заполните поле" },
  // },

  // {
  //   name: "photos",
  //   label: "Фото",
  //   placeholder: "Добавьте фото",
  //   type: "file",
  //   validation: { required: "Заполните поле" },
  // },
];

export const selectFields = [
  {
    name: "property_type",
    label: "Тип недвижимости",
    placeholder: "Выбрать",
    apiKey: "property_type",
    type: "select",
    validation: { required: "Заполните поле" },
  },
  {
    name: "transaction_type",
    label: "Тип сделки",
    placeholder: "Выбрать",
    apiKey: "transaction_type",
    type: "select",
    validation: { required: "Заполните поле" },
  },
  {
    name: "offer_type",
    label: "Тип предложения",
    placeholder: "Выбрать",
    apiKey: "offer_type",
    type: "select",
    validation: { required: "Заполните поле" },
  },
  {
    name: "documents",
    label: "Тип документа",
    placeholder: "Выбрать",
    apiKey: "document_type",
    type: "select",
    validation: { required: "Заполните поле" },
  },
  {
    name: "payment_type",
    label: "Тип оплаты",
    placeholder: "Выбрать",
    apiKey: "payment_type",
    type: "select",
    validation: { required: "Заполните поле" },
  },
  {
    name: "object_status",
    label: "Статус объекта",
    placeholder: "Выбрать",
    apiKey: "object_status",
    type: "select",
    validation: { required: "Заполните поле" },
  },
  {
    name: "district_id",
    label: "Район",
    placeholder: "Выбрать район",
    apiKey: "district_id",
    type: "select",
    validation: { required: "Заполните поле" },
  },
  {
    name: "agents",
    label: "Агенты",
    placeholder: "Выберите агентов",
    apiKey: "agents",
    type: "select",
  },
  // {
  //   name: "district_type_id",
  //   label: "Тип района",
  //   placeholder: "Выбрать тип района",
  //   type: "select",
  // },
];

export const secondaryFields = [
  {
    name: "property_series",
    label: "Серия объекта",
    placeholder: "Введите серию",
    type: "text",
    validation: { required: "Заполните поле" },
  },
  {
    name: "rooms",
    label: "Количество комнат",
    placeholder: "Выберите количество комнат",
    apiKey: "rooms",
    type: "select",
    validation: { required: "Заполните поле" },
  },
  {
    name: "floor",
    label: "Этаж",
    placeholder: "Выберите этаж",
    apiKey: "floor",
    type: "select",
    validation: { required: "Заполните поле" },
  },
  {
    name: "from_all_floors",
    label: "Этажность",
    placeholder: "Введите этажность",
    type: "number",
    validation: { required: "Заполните поле" },
  },
  {
    name: "property_condition",
    label: "Состояние объекта",
    placeholder: "Выберите",
    apiKey: "property_condition",
    type: "select",
    validation: { required: "Заполните поле" },
  },
  {
    name: "communications",
    label: "Коммуникации",
    placeholder: "Выберите коммуникации",
    apiKey: "communication_type",
    type: "select",
    validation: { required: "Заполните поле" },
  },
];
export const commercialFields = [
  {
    name: "type_commercial_property",
    label: "Тип коммерческой недвижимости",
    placeholder: "Тип коммерческой недвижимости",
    type: "text",
    validation: { required: "Заполните поле" },
  },
  {
    name: "floor",
    label: "Этаж",
    placeholder: "Выберите этаж",
    apiKey: "floor",
    type: "select",
    validation: { required: "Заполните поле" },
  },
  {
    name: "from_all_floors",
    label: "Этажность здания",
    placeholder: "Введите этажность",
    type: "number",
    validation: { required: "Заполните поле" },
  },
  // {
  //   name: "price_per_month",
  //   label: "Цена за месяц",
  //   placeholder: "1000 сом",
  //   type: "text",
  //   validation: { required: "Заполните поле" },
  // },
];
export const landAndHouseFields = [
  {
    name: "land_type",
    label: "Тип участка",
    placeholder: "Тип участка",
    type: "select",
    selectOptions: [
      {value: "Дом", label: "1"},
      {value: "Участок", label: "2"},
    ],
    validation: { required: "Заполните поле" },
  },
  {
    name: "rooms",
    label: "Количество комнат",
    placeholder: "Выберите количество комнат",
    apiKey: "rooms",
    type: "select",
    validation: { required: "Заполните поле" },
  },
  {
    name: "furniture",
    label: "Мебель",
    placeholder: "Выберите варианты",
    apiKey: "furniture_type",
    type: "select",
    validation: { required: "Заполните поле" },
  },
  {
    name: "hundredth",
    label: "Площадь участка (в сотках)",
    placeholder: "10",
    type: "number",
    validation: { required: "Заполните поле" },
  },
  {
    name: "communications",
    label: "Коммуникации",
    placeholder: "Выберите коммуникации",
    apiKey: "communication_type",
    type: "select",
    validation: { required: "Заполните поле" },
  },
];
export const luxuryFields = [
  {
    name: "rooms",
    label: "Количество комнат",
    placeholder: "Выберите количество комнат",
    apiKey: "rooms",
    type: "select",
    validation: { required: "Заполните поле" },
  },
  {
    name: "floor",
    label: "Этаж",
    placeholder: "Выберите этаж",
    apiKey: "floor",
    type: "select",
    validation: { required: "Заполните поле" },
  },
  {
    name: "from_all_floors",
    label: "Этажность здания",
    placeholder: "Введите этажность здания",
    type: "number",
    validation: { required: "Заполните поле" },
  },
  {
    name: "communications",
    label: "Коммуникации",
    placeholder: "Выберите коммуникации",
    apiKey: "communication_type",
    type: "select",
    validation: { required: "Заполните поле" },
  },
  {
    name: "furniture",
    label: "Мебель",
    placeholder: "Полный комплект",
    apiKey: "furniture_type",
    type: "select",
    validation: { required: "Заполните поле" },
  },
  {
    name: "property_condition",
    label: "Состояние недвижимости",
    placeholder: "Выбрать",
    apiKey: "property_condition",
    type: "select",
    validation: { required: "Заполните поле" },
  },
  {
    name: "residentialId",
    label: "Жилые помещения",
    placeholder: "Выбрать",
    apiKey: "residentials",
    type: "select",
    validation: { required: "Заполните поле" },
  },
];
export const parkingFields = [
  {
    name: "residentialId",
    label: "Жилые помещения",
    placeholder: "Выбрать",
    apiKey: "residentials",
    type: "select",
    validation: { required: "Заполните поле" },
  },
];
export const contactFields = [
  {
    name: "phone_number",
    label: "Номер телефона",
    placeholder: "Введите номер телефона",
    type: "number",
    validation: { required: "Заполните поле" },
  },
  {
    name: "whatsapp",
    label: "Номер Whats App",
    placeholder: "Введите номер Whats App",
    type: "number",
    validation: { required: "Заполните поле" },
  },
  {
    name: "telegram",
    label: "Телеграм",
    placeholder: "Введите телеграм",
    type: "text",
    validation: { required: "Заполните поле" },
  },
  {
    name: "gmail",
    label: "Эл.почта",
    placeholder: "Введите почту",
    type: "text",
    validation: { required: "Заполните поле" },
  },
  {
    name: "address",
    label: "Адрес",
    placeholder: "Введите адрес",
    type: "text",
    validation: { required: "Заполните поле" },
  },
  {
    name: "work_schedule",
    label: "График работы",
    placeholder: "Введите график работы",
    type: "text",
    validation: { required: "Заполните поле" },
  },
];

export const profileFields = [
  { name: "name", label: "Имя", placeholder: "Введите имя" },
  { name: "surname", label: "Фамилия", placeholder: "Введите фамилию" },
  { name: "email", label: "Email", placeholder: "Введите email" },
  {
    name: "phone_number",
    label: "Номер телефона",
    placeholder: "Введите номер",
  },
  {
    name: "whats_app",
    label: "WhatsApp",
    placeholder: "Введите номер WhatsApp",
  },
  // { name: "role", label: "Роль", placeholder: "Введите роль" },
  { name: "group", label: "Группа", placeholder: "Введите группу" },
  // {
  //   name: "property",
  //   label: "Недвижимость",
  //   placeholder: "Введите недвижимость",
  // },
  // { name: "photo", label: "Фото", placeholder: "Введите ссылку на фото" },
];
export const endpointMap = {
  Вторичная: "Secondary",
  "Дома и участки": "LandAndHouse",
  Коммерческая: "Commercial",
  Элитка: "Luxury",
  Парковка: "Parking",
};
export const filterFields = [
  {
    name: "property_type",
    label: "Тип недвижимости",
    placeholder: "Выбрать",
    apiKey: "property_type",
    type: "select",
  },
  {
    name: "property_series",
    label: "Серия объекта",
    placeholder: "Выберите",
    type: "text",
  },
  {
    name: "land_type",
    label: "Тип участка",
    placeholder: "Выберите",
    selectOptions: [
      { value: "Дом", label: "Дом" },
      { value: "Участок", label: "Участок" },
    ],
    type: "select",
  },

  {
    name: "transaction_type",
    label: "Тип сделки",
    placeholder: "Выберите",
    selectOptions: [
      { value: "Аренда", label: "Аренда" },
      { value: "Продажа", label: "Продажа" },
    ],
    type: "select",
  },
  {
    name: "rooms",
    label: "Количество комнат",
    placeholder: "Выберите количество",
    apiKey: "rooms",
    type: "select",
  },
  {
    name: "district_id",
    label: "Район",
    placeholder: "Выбрать район",
    apiKey: "district_id",
    type: "select",
  },
  {
    name: "property_condition",
    label: "Состояние объекта",
    placeholder: "Выберите",
    apiKey: "property_condition",
    type: "select",
  },
  {
    name: "agents",
    label: "Агенты",
    placeholder: "Выберите агента",
    apiKey: "agents",
    type: "select",
  },
  {
    name: "property_id",
    label: "Поиск по ID ",
    placeholder: "Введите ID",
    apiKey: "property_id",
    type: "search",
  },
  {
    name: "price",
    label: "Цена",
    type: "price_range",
    fields: [
      { name: "min_price", placeholder: "Мин" },
      { name: "max_price", placeholder: "Макс" }
    ]
  },

  // {
  //   name: "land_type",
  //   label: "Тип участка",
  //   placeholder: "Выберите тип участка",
  //   apiKey: "land_type",
  //   type: "select",
  // },

  // {
  //   name: "object_status",
  //   label: "Статус объекта",
  //   placeholder: "Выбрать",
  //   apiKey: "object_status",
  //   type: "select",
  // },
  // {
  //   name: "payment_type",
  //   label: "Тип оплаты",
  //   placeholder: "Выбрать",
  //   apiKey: "payment_type",
  //   type: "select",
  // },
  // {
  //   name: "documents",
  //   label: "Тип документа",
  //   placeholder: "Выбрать",
  //   apiKey: "document_type",
  //   type: "select",
  // },
];
export const detailsFields = [
  {
    name: "transaction_type",
    label: "Тип сделки",
    placeholder: "Выбрать",
    apiKey: "transaction_type",
    type: "select",
  },
  {
    name: "property_type",
    label: "Тип недвижимости",
    placeholder: "Выбрать",
    apiKey: "property_type",
    type: "select",
  },
  {
    name: "payment_type",
    label: "Тип оплаты",
    placeholder: "Выбрать",
    apiKey: "payment_type",
    type: "select",
  },
  {
    name: "price",
    label: "Цена",
    placeholder: "Выбрать",
    apiKey: "price",
    type: "select",
  },
  {
    name: "on_hand",
    label: "Цена на руки",
    placeholder: "Выбрать",
    apiKey: "on_hand",
    type: "select",
  },
  {
    name: "land_type",
    label: "Тип участка",
    placeholder: "Выбрать",
    apiKey: "land_type",
    type: "select",
  },
  {
    name: "hundredth",
    label: "Площадь участка (в сотках)",
    placeholder: "Выбрать",
    apiKey: "hundredth",
    type: "select",
  },
  {
    name: "area",
    label: "Общая площадь (м²)",
    placeholder: "Выбрать",
    apiKey: "area",
    type: "select",
  },
  {
    name: "documentType",
    label: "Тип документа",
    placeholder: "Выбрать",
    apiKey: "documentType",
    type: "select",
  },
  {
    name: "document_type",
    label: "Тип документа",
    placeholder: "Выбрать",
    apiKey: "document_type",
    type: "select",
  },
  {
    name: "offer_type",
    label: "Тип предложения",
    placeholder: "Выбрать",
    apiKey: "offer_type",
    type: "select",
  },
  {
    name: "communications",
    label: "Коммуникации",
    placeholder: "Выберите коммуникации",
    apiKey: "communication_type",
    type: "select",
  },
  {
    name: "rooms",
    label: "Количество комнат",
    placeholder: "3",
    apiKey: "rooms",
    type: "select",
  },
  {
    name: "floor",
    label: "Этаж",
    placeholder: "1",
    apiKey: "floor",
    type: "select",
  },
  {
    name: "property_condition",
    label: "Состояние объекта",
    placeholder: "Выберите",
    apiKey: "property_condition",
    type: "select",
  },

  {
    name: "furniture",
    label: "Мебель",
    placeholder: "Выберите",
    apiKey: "furniture",
    type: "select",
  },
  {
    name: "object_status",
    label: "Статус объекта",
    placeholder: "Выбрать",
    apiKey: "object_status",
    type: "select",
  },
  {
    name: "district",
    label: "Район",
    placeholder: "Выбрать район",
    apiKey: "district_id",
    type: "select",
  },
  {
    name: "description",
    label: "Описание",
    placeholder: "Введите описание",
    apiKey: "description",
    type: "select",
  },

];
